import { render, staticRenderFns } from "./ProjectBox.vue?vue&type=template&id=36466b68&scoped=true"
import script from "./ProjectBox.vue?vue&type=script&lang=js"
export * from "./ProjectBox.vue?vue&type=script&lang=js"
import style0 from "./ProjectBox.vue?vue&type=style&index=0&id=36466b68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36466b68",
  null
  
)

export default component.exports